/**
 * ss-header-sticky.js — Sticky header behaviour (snippet-safe)
 * Targets .ss-shell[data-ss-sticky-header] — no Shopify section wrapper required.
 */
(function () {
  'use strict';

  function HeaderSticky(el) {
    this.el = el;
    this.header = el.closest('.ss-chrome-header') || el;
    this.headerBounds = {};
    this.currentScrollTop = 0;
    this.preventReveal = false;
    this.preventHide = false;
    this.predictiveSearch = this.el.querySelector('[data-ss-search-results]');
    this.onScrollHandler = this.onScroll.bind(this);
    this.hideHeaderOnScrollUp = function () {
      this.preventReveal = true;
    }.bind(this);
    this.el.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.addEventListener('scroll', this.onScrollHandler, { passive: true });
    this.createObserver();
  }

  HeaderSticky.prototype.createObserver = function () {
    var self = this;
    var observer = new IntersectionObserver(function (entries, obs) {
      self.headerBounds = entries[0].intersectionRect;
      obs.disconnect();
    });
    observer.observe(this.header);
  };

  HeaderSticky.prototype.isOverlayOpen = function () {
    return (
      document.body.classList.contains('ss-search-open') ||
      document.body.classList.contains('ss-drawer-open') ||
      document.body.classList.contains('ss-qv-open') ||
      document.body.classList.contains('overflow-hidden') ||
      document.body.classList.contains('ss-pdp-lb-open') ||
      !!document.querySelector('.ss-nav__details[open]') ||
      !!document.querySelector('.ss-qv.is-open') ||
      !!document.querySelector('cart-drawer.active') ||
      !!document.querySelector('[data-ss-account].is-open')
    );
  };

  HeaderSticky.prototype.onScroll = function () {
    if (!this.header) return;
    if (this.isOverlayOpen()) return;

    var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    if (this.predictiveSearch && this.predictiveSearch.hidden === false && this.predictiveSearch.innerHTML) return;

    var bottom = this.headerBounds.bottom || this.header.offsetHeight || 80;

    if (scrollTop > this.currentScrollTop && scrollTop > bottom) {
      if (!this.preventHide) requestAnimationFrame(this.hide.bind(this));
    } else if (scrollTop < this.currentScrollTop && scrollTop > bottom) {
      if (!this.preventReveal) {
        requestAnimationFrame(this.reveal.bind(this));
      } else {
        window.clearTimeout(this.isScrolling);
        this.isScrolling = setTimeout(
          function () {
            this.preventReveal = false;
          }.bind(this),
          66
        );
        requestAnimationFrame(this.hide.bind(this));
      }
    } else if (scrollTop <= (this.headerBounds.top || 0)) {
      requestAnimationFrame(this.reset.bind(this));
    }

    this.currentScrollTop = scrollTop;
    this.el.classList.toggle('is-scrolled', scrollTop > 12);
  };

  HeaderSticky.prototype.hide = function () {
    if (!this.header || this.isOverlayOpen()) return;
    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
    this.closeMenuDisclosure();
  };

  HeaderSticky.prototype.reveal = function () {
    if (!this.header) return;
    this.header.classList.add('shopify-section-header-sticky', 'animate');
    this.header.classList.remove('shopify-section-header-hidden');
  };

  HeaderSticky.prototype.reset = function () {
    if (!this.header) return;
    this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
  };

  HeaderSticky.prototype.closeMenuDisclosure = function () {
    this.disclosures = this.disclosures || this.header.querySelectorAll('.ss-nav__details');
    this.disclosures.forEach(function (disclosure) {
      disclosure.removeAttribute('open');
    });
  };

  function syncPreventHide() {
    document.querySelectorAll('[data-ss-sticky-header]').forEach(function (el) {
      if (!el._ssStickyInstance) return;
      var open = !!document.querySelector('.ss-nav__details[open]');
      el._ssStickyInstance.preventHide = open;
      el.preventHide = open;
    });
  }

  document.addEventListener('toggle', syncPreventHide, true);

  function init() {
    document.querySelectorAll('[data-ss-sticky-header]').forEach(function (el) {
      if (el._ssStickyInit) return;
      el._ssStickyInit = true;
      el._ssStickyInstance = new HeaderSticky(el);
    });
    if (!customElements.get('sticky-header')) {
      customElements.define(
        'sticky-header',
        class extends HTMLElement {
          connectedCallback() {
            if (this._ssStickyInit) return;
            this._ssStickyInit = true;
            this.setAttribute('data-ss-sticky-header', '');
            this._ssStickyInstance = new HeaderSticky(this);
          }
        }
      );
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
